import gql from 'graphql-tag';

export const GET_CUSTOM_DASHBOARD_WIDGET_DATA = gql`
  query CustomDashboard_getWidgetData(
    $granularity: GranularityInput!
    $startDate: Timestamp!
    $endDate: Timestamp!
    $projectId: Id!
    $timezone: Int!
    $customDashboardWidgetMetadataId: Id!
    $objectIds: [Id!]
    $clippingId: Id
    $customDashboardId: Id
  ) {
    customDashboard_getWidgetData(
      granularity: $granularity
      startDate: $startDate
      endDate: $endDate
      projectId: $projectId
      timezone: $timezone
      customDashboardWidgetMetadataId: $customDashboardWidgetMetadataId
      objectIds: $objectIds
      clippingId: $clippingId
      customDashboardId: $customDashboardId
    ) {
      responseType
      details {
        numericWithGrowth {
          recentValue
          growth
          pastValue
          contentType
          title
        }
        nameValue {
          name
          value
        }
        chronologicalGroup {
          contentType
          values {
            timestamp
            value
          }
        }
        chronological {
          contentType
          values {
            timestamp
            value
          }
        }
        user {
          socialMedia
          fromName
          value
          talk
          followers
          like
          share
          comment
          engagement
          view
          following
          openness
          conscientiousness
          extraversion
          agreeableness
          neuroticism
        }
        peakTime {
          max
          min
          peakTimeValue {
            name
            data
          }
        }
        table {
          header
          body {
            cells {
              cellName
              cellValue
            }
          }
          rowCount
        }
        groupSentiment {
          groupName
          positive
          negative
          neutral
        }
        numericOutput {
          name
          value
        }
        onlineMediaStream {
          originalId
          createdAt
          datePublished
          displayPicture
          title
          content
          link
          isEdited
          people
          place
          quote
          sentiment
          sourceName
          updatedAt
          writer
          prValues
          symbol
          labelArticleList {
            id
            name
            displayName
            colorType
            isActive
            createdAt
            clippingId
          }
          clippingList {
            id
            name
            isActive
            phrases
            excludePhrases
            createdAt
            startDate
            projectId
          }
          listOfClippingId
          keywordList
          quotationWithPerson {
            text
            person
          }
        }
        quotationWithPersonGroup {
          name
          value
          list {
            name
            value
            content
          }
        }
        summarySocmed {
          generalSummary
          highlightIssuePositive
          highlightIssueNegative
          sourceType
          startDate
          endDate
          createdAt
        }
        summaryOnm {
          generalSummary
          highlightIssuePositive
          highlightIssueNegative
          sourceType
          startDate
          endDate
          createdAt
        }
      }
    }
  }
`;

export const GET_CUSTOM_DASHBOARD_WIDGET_METADATA = gql`
  query CustomDashboard_getCustomDashboardWidgetMetadata(
    $dashboardSourceType: DashboardSourceType!
  ) {
    customDashboard_getCustomDashboardWidgetMetadata(
      dashboardSourceType: $dashboardSourceType
    ) {
      id
      metric
      description
      size
      displayName
      title
      visualization
      category
      source_type
    }
  }
`;

export const GET_CUSTOM_DASHBOARD = gql`
  query customDashboard_getCustomDashboard($projectId: Id!) {
    customDashboard_getCustomDashboard(projectId: $projectId) {
      id
      name
      displayName
      createdAt
      sourceType
      clippingOnm {
        id
        name
        createdAt
        phrases
        startingDate
        startDate
        excludePhrases
      }
      clippingOfm {
        id
        name
        createdAt
        phrases
        startingDate
        startDate
      }
      objectList {
        id
        socialMedia
        streamType
        content
        extraContent
        objectName
        isHashtag
        createdAt
        openApiId
        displayPicture
        includes
        excludes
        languages
      }
      objectGroupList {
        id
        name
        displayName
        createdAt
        objectList {
          id
          socialMedia
          streamType
          content
          extraContent
          objectName
          isHashtag
          createdAt
          openApiId
          displayPicture
          includes
          excludes
          languages
          isEntity
          entityName
          isAuthorizeTiktok
        }
      }
      customDashboardWidgetMetadataList {
        id
        metric
        description
        size
        displayName
        title
        visualization
        category
        source_type
      }
    }
  }
`;

export const CUSTOM_DASHBOARD_DOWNLOAD_PDF = gql`
  query customDashboard_downloadPdf(
    $granularity: GranularityInput!
    $startDate: Timestamp!
    $endDate: Timestamp!
    $objectIds: [Id!]
    $projectId: Id!
    $timezone: Int!
    $customDashboardId: Id!
    $isWhiteLabel: Boolean
  ) {
    customDashboard_downloadPdf(
      projectId: $projectId
      objectIds: $objectIds
      startDate: $startDate
      endDate: $endDate
      timezone: $timezone
      customDashboardId: $customDashboardId
      granularity: $granularity
      isWhiteLabel: $isWhiteLabel
    ) {
      url
    }
  }
`;

export const CUSTOM_DASHBOARD_RECOMMENDATION_SOCMED = gql`
  query customDashboard_getRecommendationSocmed(
    $granularity: GranularityInput!
    $startDate: Timestamp!
    $endDate: Timestamp!
    $projectId: Id!
    $timezone: Int!
    $customDashboardWidgetMetadataId: Id!
    $objectIds: [Id!]
    $clippingId: Id
    $customDashboardId: Id
  ) {
    customDashboard_getRecommendationSocmed(
      granularity: $granularity
      startDate: $startDate
      endDate: $endDate
      projectId: $projectId
      timezone: $timezone
      customDashboardWidgetMetadataId: $customDashboardWidgetMetadataId
      objectIds: $objectIds
      clippingId: $clippingId
      customDashboardId: $customDashboardId
    )
  }
`;

export const CUSTOM_DASHBOARD_RECOMMENDATION_ONM = gql`
  query customDashboard_getRecommendationOnlineNews(
    $granularity: GranularityInput!
    $startDate: Timestamp!
    $endDate: Timestamp!
    $projectId: Id!
    $timezone: Int!
    $customDashboardWidgetMetadataId: Id!
    $objectIds: [Id!]
    $clippingId: Id
    $customDashboardId: Id
  ) {
    customDashboard_getRecommendationOnlineNews(
      granularity: $granularity
      startDate: $startDate
      endDate: $endDate
      projectId: $projectId
      timezone: $timezone
      customDashboardWidgetMetadataId: $customDashboardWidgetMetadataId
      objectIds: $objectIds
      clippingId: $clippingId
      customDashboardId: $customDashboardId
    )
  }
`;
